import { AppState } from '../app.state';

export const getAuthenticationStatus = (state: AppState): boolean =>
  state.authentication.isAuthenticated;

export const getAuthenticationToken = (state: AppState): string | null =>
  state.authentication.token;

export const getAuthenticationError = (state: AppState): string | null =>
  state.authentication.error;

export const getAuthenticationLoading = (state: AppState): boolean =>
  state.authentication.isLoading;
